import React from 'react';
import { motion } from 'framer-motion';
import { marketData } from '../../utils/portfolioData';
import { MiniSparkline } from './MiniSparkline';
const trending = marketData.slice().sort((a, b) => Math.abs(b.change24h) - Math.abs(a.change24h)).slice(0, 5);
export function TrendingRow() {
  return <div data-id="element-1368">
      <h2 className="text-sm font-heading text-text-primary mb-3" data-id="element-1369">
        🔥 Trending
      </h2>
      <div className="flex gap-3 overflow-x-auto scrollbar-hide pb-1" data-id="element-1370">
        {trending.map((coin, i) => <motion.div key={coin.symbol} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.35,
        delay: i * 0.07
      }} className="min-w-[200px] glass-border rounded-[20px] p-4 flex-shrink-0" data-id="element-1371">
            <div className="flex items-center gap-2 mb-3" data-id="element-1372">
              <img src={coin.logo} alt={coin.name} className="w-6 h-6 object-contain" data-id="element-1373" />
              <div data-id="element-1374">
                <div className="text-sm font-medium text-text-primary" data-id="element-1375">
                  {coin.symbol}
                </div>
                <div className="text-[10px] text-text-tertiary" data-id="element-1376">
                  {coin.name}
                </div>
              </div>
            </div>
            <div className="mb-2" data-id="element-1377">
              <MiniSparkline data={coin.priceHistory} isPositive={coin.change24h >= 0} width={168} height={36} data-id="element-1378" />
            </div>
            <div className="flex items-center justify-between" data-id="element-1379">
              <span className="font-numbers text-sm text-text-primary" data-id="element-1380">
                $
                {coin.price.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
              </span>
              <span className={`font-numbers text-xs font-medium ${coin.change24h >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-1381">
                {coin.change24h >= 0 ? '+' : ''}
                {coin.change24h.toFixed(2)}%
              </span>
            </div>
          </motion.div>)}
      </div>
    </div>;
}